import { render, staticRenderFns } from "./VehiculeActivites.vue?vue&type=template&id=b5dd5cb4&"
import script from "./VehiculeActivites.vue?vue&type=script&lang=js&"
export * from "./VehiculeActivites.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports